/**
 * Transport Script select + Replay + status chip.
 */

import type { ExhibitApp } from "../../app/ExhibitApp";

export function bindChoreoChrome(app: ExhibitApp): () => void {
  const choreoSel = document.getElementById(
    "choreo-script",
  ) as HTMLSelectElement | null;
  const scriptStatus = document.getElementById("script-status");
  const choreoReplay = document.getElementById(
    "btn-choreo-replay",
  ) as HTMLButtonElement | null;

  const sync = (): void => {
    const id = app.choreographyId;
    const st = app.choreographyStatus;
    const label = app.choreographyLabel;

    if (choreoSel && id && choreoSel.value !== id) {
      choreoSel.value = id;
    }
    if (choreoSel && !id && st === "idle" && choreoSel.value !== "") {
      choreoSel.value = "";
    }

    if (scriptStatus) {
      if (!id || st === "idle") {
        scriptStatus.hidden = true;
        scriptStatus.textContent = "";
        scriptStatus.removeAttribute("data-state");
      } else if (st === "running") {
        scriptStatus.hidden = false;
        scriptStatus.dataset.state = "running";
        scriptStatus.textContent = "Running…";
        scriptStatus.title = label ? `Running “${label}”` : "Script running";
      } else {
        scriptStatus.hidden = false;
        scriptStatus.dataset.state = "done";
        scriptStatus.textContent = "Done";
        scriptStatus.title = label
          ? `“${label}” finished — Replay to run again`
          : "Script finished";
      }
    }

    if (choreoReplay) {
      const show = !!id && st !== "idle";
      choreoReplay.hidden = !show;
      choreoReplay.disabled = st === "running";
      choreoReplay.textContent = st === "running" ? "Running…" : "Replay";
      choreoReplay.title =
        st === "running"
          ? "Script is still running"
          : id
            ? "Run the selected script again"
            : "Replay";
    }
  };

  if (choreoSel) {
    choreoSel.title =
      "Pick a recipe — it runs immediately and stays selected. Use Replay to run it again. Open ? for the catalog.";
    for (const s of app.listChoreographyScripts()) {
      const opt = document.createElement("option");
      opt.value = s.id;
      opt.textContent = s.label;
      opt.title = `${s.summary}${s.durationHint ? ` · ${s.durationHint}` : ""}\n\n${s.detail}`;
      choreoSel.appendChild(opt);
    }
    choreoSel.addEventListener("change", () => {
      const id = choreoSel.value;
      if (!id) {
        app.clearChoreography();
        sync();
        return;
      }
      app.runChoreographyScript(id);
      sync();
    });
  }

  if (choreoReplay) {
    choreoReplay.addEventListener("click", () => {
      const id = app.choreographyId ?? choreoSel?.value ?? "";
      if (!id) return;
      app.runChoreographyScript(id);
      sync();
    });
  }

  sync();
  return sync;
}
